import React from 'react';
import { Expander, ExpanderItem } from '@aws-amplify/ui-react';
import '../styles/help.css';
import '../styles/channelLayoutStyles.css';
  
function Help () {
      return (
            <div className="help">
                  <p className="help-title">Do you have questions?</p>
                  <div className="question">
                        <Expander type="multiple">
                              <ExpanderItem title="What is the blue dot test?" value="item-1">
                                    This is a test that displays a blue dot in the lower right hand corner of a stream 
                                    to help observers ensure that graphics are active and working before deploying the full crawl. 
                              </ExpanderItem>
                        </Expander>
                  </div>
                  <div className="question">
                        <Expander type="multiple">
                              <ExpanderItem title="How can I see the current crawl text?" value="item-2">
                                    The default text displays the current crawl text that would appear if a stream were 
                                    active. This text is grayed out.
                              </ExpanderItem>
                        </Expander>
                  </div>
                  <div className="question">
                        <Expander type="multiple">
                              <ExpanderItem title="How can I preview the updated crawl text?" value="item-3">
                                    Each channel’s player displays the output of the channel with graphics (if active). The crawl text can be viewed here. 
                              </ExpanderItem>
                        </Expander>
                  </div>
                  <div className="question">
                        <Expander type="multiple">
                              <ExpanderItem title="What is the difference between fixed and immediate action start time?" value="item-4">
                                    Fixed times specify a date and time. The format includes month, day, year, hours, minutes, and seconds. Immediate action start times will 
                                    activate graphics as soon as the action is successfully applied to the media live channel. 
                              </ExpanderItem>
                        </Expander>
                  </div>
                  <div className="question">
                        <Expander type="multiple">
                              <ExpanderItem title="How does the manually run crawl button work?" value="item-4">
                                    The crawl can be run forcibly, outside of SCTE triggers. The manual crawl button will send a call to turn off the 
                                    ticker, pause, and then turn it back on so that it's visible on the feed.
                              </ExpanderItem>
                        </Expander>
                  </div>
                  <div className="question">
                        <Expander type="multiple">
                              <ExpanderItem title="Why don't I see changes immediately on the feed?" value="item-4">
                                    The video comes from a HLS output of the MediaLive channel. This output is stored in a AWS S3 bucket. When using the
                                    manifest file URLs from a S3 bucket, there is a delay. Activating features such as blue dot test or manual crawl run
                                    will instantly send an API call to Singular, but they may not be visible on the feed for up to 30 seconds. 
                              </ExpanderItem>
                        </Expander>
                  </div>
                  <div className="question">
                        <Expander type="multiple">
                              <ExpanderItem title="What does the delay do when adding an action" value="item-4">
                                    The delay option will delay graphics on a channel. When a call is made to modify the ticker or blue dot, those changes
                                    are delayed on the feed by the amount of seconds input in the delay field. 
                              </ExpanderItem>
                        </Expander>
                  </div>
                  <p className="help-footer">For additional assistance, reach out to Video Streaming Engineering (VSE - videostreaming@support.nbcuni.com).</p>
            </div>
      );
}
export default Help;
